"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTab = void 0;
var breakpoints_1 = require("../../../theme/global/breakpoints");
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
exports.MuiTab = {
    root: __assign(__assign({}, typography_1.typography.subtitle1), (_a = { overflow: 'visible', minHeight: 27 }, _a[breakpoints_1.breakpoints.up('sm')] = {
        minWidth: 0,
        marginRight: 24,
        paddingLeft: 0,
        paddingRight: 0,
        '&:last-child': {
            marginRight: 0,
        },
    }, _a)),
    textColorPrimary: {
        color: palette_1.palette.grey[600],
        '&:hover, &:focus': {
            color: palette_1.palette.text.primary,
        },
        '&:active': {
            color: palette_1.palette.text.primary,
        },
        '&:disabled': {
            color: palette_1.palette.text.disabled,
        },
        '&$selected': {
            color: palette_1.palette.text.primary,
        },
    },
};
